import { gql } from 'graphql-request';
import { MagicEventFragment } from './MagicEventFragment';

export const ExperienceEventFragment = gql`
  ${MagicEventFragment}
  fragment ExperienceEvent on Event {
    ...MagicEvent
    isSubscribed
    exportedToExperiences {
      id
      title
    }
    origin {
      sourceId
      kind
      experienceId
      title
      color
      publicUrl
      editUrl
      role
    }
  }
`;
